import { CardNumberElement } from "@stripe/react-stripe-js"
import { StripeCardNumberElementChangeEvent } from "@stripe/stripe-js"
import React, { useState } from "react"

interface StripeCardNumberInputProps {
  onChange?: (event: StripeCardNumberElementChangeEvent, error: string | undefined) => void
  className?: string
  isWidgetsCard?: boolean
}

const StripeCardNumberInput = ({
  onChange,
  className,
  isWidgetsCard,
}: StripeCardNumberInputProps) => {
  const [error, setError] = useState<string>()

  const inputStyle = {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    color: "#363741",
    "::placeholder": {
      color: "#898A93",
    },
    backgroundColor: "#FFFFFF",
  }
  return (
    <div aria-invalid={!!error} className={className}>
      <label className={`text12Medium mb-1 flex items-center justify-start text-neutral-900`}>
        Card Number
        <span className={"ml-[3px] text-red-600"}>*</span>
      </label>
      <div className={"flex flex-1 flex-col items-start gap-1"}>
        <div
          // className={`
          //   w-full rounded-md border border-neutral-200 bg-whiteBlack-100 px-4 py-[11px]
          //   ${error ? 'border-red-600' : 'border-neutral-200'}
          // `}
          className={`w-full rounded-md border ${isWidgetsCard ? "border-neutral-450" : "border-neutral-200"} bg-whiteBlack-100 px-4 py-[11px] ${error ? "border-red-600" : "border-neutral-200"}`}
          data-testid={"card-number-element"}
        >
          <CardNumberElement
            onChange={(event) => {
              setError(event?.error?.message)
              onChange?.(event, event?.error?.message)
            }}
            options={{
              style: {
                base: inputStyle,
              },
            }}
            data-testid={"card-number-element"}
          />
        </div>
        {error && <p className={`text12Regular text-red-600`}>{error}</p>}
      </div>
    </div>
  )
}

export default StripeCardNumberInput
